import posthog from "posthog-js";

import { getApiErrorMessage, getApiRequestErrorContext } from "@/lib/apiError";

import { AnalyticsProperty, type ErrorSurfaceName } from "./constants";

export interface ReportUserFacingErrorOptions {
  error: unknown;
  surface: ErrorSurfaceName;
  properties?: Record<string, unknown>;
}

export function reportUserFacingError({
  error,
  properties,
  surface,
}: ReportUserFacingErrorOptions) {
  if (process.env.NEXT_PUBLIC_ENABLE_ANALYTICS !== "true") {
    return;
  }

  const apiRequestError = getApiRequestErrorContext(error);

  posthog.captureException(error, {
    [AnalyticsProperty.SURFACE]: surface,
    [AnalyticsProperty.ERROR_MESSAGE]: getApiErrorMessage(error),
    [AnalyticsProperty.API_METHOD]: apiRequestError?.method,
    [AnalyticsProperty.API_PATHNAME]: apiRequestError?.pathname,
    [AnalyticsProperty.API_STATUS]: apiRequestError?.status,
    [AnalyticsProperty.API_STATUS_TEXT]: apiRequestError?.statusText,
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? "development",
    vpcName: process.env.NEXT_PUBLIC_VPC_NAME,
    ...properties,
  });
}
